export const VOUCHER = {
  STATUS: {
    BELUM_DIKLAIM: 0,
    SUDAH_DIKLAIM: 1,
    EXPIRED: 2,
  },
  STATUS_PROMO_SPEKTAKULER: {
    BELUM_DIKLAIM: 1,
    SUDAH_DIKLAIM: 2,
    EXPIRED: 3,
  }
}